import api from "../Utils/axios";
import { adminV1Base } from "../Utils/connection_strings";

export const getCMSList = (page, perPage, search_string) => {
    return api.post(`${adminV1Base}/cms/get`, {
        page,
        limit: perPage,
        keyword: search_string,
        sort: -1
    });
};

export const createCMS = (data) => {
    return api.post(`${adminV1Base}/cms/create`, data);
};

export const editCMS = (data) => {
    return api.post(`${adminV1Base}/cms/edit`, data);
};

export const deleteCMS = (id) => {
    return api.post(`${adminV1Base}/cms/delete`, { id });
};

export const handleCMSStatus = (id) => {
    return api.post(`${adminV1Base}/cms/handle-status`, { id });
};
